// extracted by mini-css-extract-plugin
export var container = "_9o-0";
export var icon = "_9o-1";
export var text = "_9o-2";